import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import MarteMeo from './pages/MarteMeo';
import Theraplay from './pages/Theraplay';
import Presentations from './pages/Presentations';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hvem-er-jeg" element={<About />} />
        <Route path="/marte-meo" element={<MarteMeo />} />
        <Route path="/theraplay" element={<Theraplay />} />
        <Route path="/oplaeg" element={<Presentations />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/privatlivspolitik" element={<PrivacyPolicy />} />
      </Routes>
    </Layout>
  );
}

export default App;
